export default __webpack_public_path__ + "static/Spaceport_Doors_Opening-5557cbe6cc66eaa8f6b0c2c9639701d1.mp4";